import React from 'react'

// Example: const PrimaryButton = Styled(Button, styles.primary)
const Styled = function <T>(Type: T, style: object): T {
  // @ts-ignore
  return React.forwardRef((props, ref) => (
    // @ts-ignore
    <Type ref={ref} {...props} style={{...style, ...props.style}} />
  ))
}

export default Styled
